import React from 'react';
import { getIsMobileApp } from '../../../../utils/mobileApp';
import { BottomSheet, Dialog, useMediaQuery, useTheme, IconButton, IconWrapper, Box } from 'omaha-design-system';
import type { BottomSheetProps } from 'omaha-design-system';
import { X } from '@phosphor-icons/react';
import type { SxProps, Theme } from 'omaha-design-system';

interface BottomSheetOrDialogProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;

  // BottomSheet specific props
  detent?: BottomSheetProps['detent'];
  footer?: React.ReactNode;

  // Dialog specific props
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  fullWidth?: boolean;
  
  // Close button control
  showCloseButton?: boolean;

  // Shared styling
  PaperProps?: {
    sx?: SxProps<Theme>;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  };
}

export const BottomSheetOrDialog: React.FC<BottomSheetOrDialogProps> = ({
  open,
  onClose,
  children,
  detent,
  footer,
  maxWidth = 'sm',
  fullWidth = true,
  showCloseButton = true,
  PaperProps,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <BottomSheet
        open={open}
        onClose={onClose}
        detent={detent}
        footer={footer}
        PaperProps={PaperProps}
        style={getIsMobileApp() ? { zIndex: 1400 } : undefined}
      >
        {children}
      </BottomSheet>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={PaperProps}
    >
      <Box position="relative">
        {showCloseButton && (
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              zIndex: 1,
              color: '#F2F2F3',
            }}
            size="small"
          >
            <IconWrapper asset={<X />} size="SM" />
          </IconButton>
        )}
        {children}
      </Box>
    </Dialog>
  );
};

export default BottomSheetOrDialog;
